/**
 * roles.tsx
 * * Centralized role definitions for the Bolt WOOD ecosystem.
 * This file serves as the single source of truth for Role-Based Access Control (RBAC).
 */

/**
 * Constant representing the primary administrative role.
 * In Strapi, ensure the role name matches this value exactly.
 */
export const ADMIN_ROLE = 'Admin';

/**
 * Type definition for User Roles to ensure type safety across components.
 */
export type UserRole = typeof ADMIN_ROLE;

/**
 * Utility to verify if a given role string matches the Admin role.
 * @param role - The role name received from the API/Strapi.
 * @returns boolean indicating if the user has administrative privileges.
 */
export const isAdmin = (role: string | null | undefined): boolean => {
	return role === ADMIN_ROLE;
};
